import { Injectable } from '@angular/core';

// export const rbTheming = {
//   `rb-primary`: `$rb-primary`,
//   `rb-accent`: `$rb-accent`,
//   `rb-warn`: `$rb-warn`,
// };

@Injectable({
  providedIn: 'root'
})
export class ThemingManegerService {

  constructor() { }

  changeTheme(obj) {
    this.setPrimaryThemeValues(obj.rbMainPalette);
    this.setAccentThemeValues(obj.rbAccentPalette);
  }

  private setPrimaryThemeValues(colorArray: []) {
    let mainColorValue = ``;
    for (const [index, color] of colorArray.entries()) {
      document.documentElement.style.setProperty(`--rb-primary-theme-${color[`name`]}`, color[`hex`]);
      document.documentElement.style.setProperty(`--rb-primary-theme-contrast-${color[`name`]}`,
      color[`darkContrast`] === true ? `#000` : `#fff`);
      if (index === 5) {
        mainColorValue = color[`hex`];
      }
    }
    document.documentElement.style.setProperty(`--rb-primary-theme-RB900`, mainColorValue + `4d`);
    document.documentElement.style.setProperty(`--rb-primary-theme-contrast-RB900`, `#fff`);
  }

  private setAccentThemeValues(colorArray: []) {
    let mainColorValue = ``;
    for (const [index, color] of colorArray.entries()) {
      document.documentElement.style.setProperty(`--rb-accent-theme-${color[`name`]}`, color[`hex`]);
      document.documentElement.style.setProperty(`--rb-accent-theme-contrast-${color[`name`]}`,
      color[`darkContrast`] === true ? `#000` : `#fff`);
      if (index === 5) {
        mainColorValue = color[`hex`];
      }
    }
    if (mainColorValue) {
      document.documentElement.style.setProperty(`--rb-accent-theme-RB900`, mainColorValue + `4d`);
      document.documentElement.style.setProperty(`--rb-accent-theme-contrast-RB900`, `#fff`);
    }
  }
}
